import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {getMeeting, getMeetingList} from "../api/client";

import {Header} from "../components/Header";
import {CenteredSpinner, CenteredSpinner2} from "../components/CenteredSpinner";
import {setQueryString} from "../slices/usersSlice";
import {HumanDate, HumanDuration} from "../components/Helpers";
import {Customer, SeismicEmployee} from "../components/Utils";

const Section = ({title, children}) => {
    return <div style={{paddingBottom: "16px"}}>
        <div style={{backgroundColor: "white", border: "1px solid #cfd4da", borderRadius: 4, padding: 8}}>
            {title && <h3>{title}</h3>}
            {children}
        </div>
    </div>
}

const Page = ({content, page}) => {
    
    
    return <div>
        <hr />
        <a href={page.originLibraryContentId === null ? null : `/Content/${page.originLibraryContentId}`}>Page {page.pageIndex} presented for <HumanDuration duration={page.durationSeconds * 1000} /></a>
        {page.originLibraryContentVersionId !== content.contentVersionId && <div><small>This content was originally from {page.originName} page {page.originLibraryContentPageIndex}</small></div>}
        {page.sentences.length > 0 && <Section title="Discussion">
            <table>
                <thead>
                <tr>
                    <th>Speaker</th>
                    <th></th>
                </tr>
                </thead>
                {page.sentences.map(a=><tr><td style={{whiteSpace: "nowrap"}}>{a.meetingParticipantName}</td><td>{a.sentenceText}</td></tr>)}
            </table>
        </Section>}
        {page.questions.length > 0 && <Section title="Questions">
            <table>
                <thead>
                <tr>
                    <th>Speaker</th>
                    <th>Topic</th>
                    <th>Question</th>
                </tr>
                </thead>
                {page.questions.map(a=><tr><td style={{whiteSpace: "nowrap"}}>{a.speaker}</td><td style={{whiteSpace: "nowrap"}}>{a.topic}</td><td>{a.question}</td></tr>)}
            </table>
        </Section>}
    </div>
}

const Content = ({content}) => {
    return <div>
        <h5>{content.presentedByName} presented <b>{content.name}</b> for <HumanDuration duration={content.durationSeconds * 1000} /></h5>
        <p>
            {content.pages.map(a=><Page content={content} page={a} />)}
        </p>
    </div>
}

export const Meeting = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const qsId = urlParams.get('id');
    const dispatch = useDispatch();
    const [meetingList, setMeetingList] = useState([]);
    const [selectedMeetingId, setSelectedMeetingId] = useState(null);
    const [meeting, setMeeting] = useState(null);

    useEffect(() => {
        getMeetingList()
            .then(data => {
                setMeetingList(data);
                if(data.filter(a=>a.id === qsId).length > 0)
                    setSelectedMeetingId(qsId);
                else
                    setSelectedMeetingId(data[0].id);
            })
    }, []);

    useEffect(() => {
        if (selectedMeetingId === null)
            return;
        setMeeting(null);
        getMeeting(selectedMeetingId)
            .then(data => {
                setMeeting(data)
            })
    }, [selectedMeetingId]);

    const signOut = () => {
        dispatch(setAccessToken(null));
    }
    
    return <>
        <Header signOut={signOut} title="Seismic Meetings" navigateTo="/Meeting" />
        <div style={{padding: "16px"}}>
            <div style={{paddingBottom: 16}}>
                <select value={selectedMeetingId} onChange={(e) => {
                    setQueryString("id", e.target.value);
                    setSelectedMeetingId(e.target.value)
                }
                }>
                    {meetingList.map(item => (
                        <option key={item.id} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </div>
            {meeting === null && <CenteredSpinner />}
            {meeting && <div>
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <h3>{meeting.title} <HumanDate date={meeting.startTime} /></h3>
                    {meeting?.externalMeetingInfo?.externalMeetingId != null && <div><a href={`/MeetingRedirect?externalMeetingId=${encodeURIComponent(meeting?.externalMeetingInfo?.externalMeetingId)}`}>View Legacy Meeting</a></div>}
                </div>
                <Section title="Participants">
                    {meeting.participants.map(x=><span style={{paddingRight: "12px"}} key={x.displayName}>{x.isInternalUser ? <SeismicEmployee /> : <Customer/>}&nbsp;{x.displayName}</span>)}
                </Section>
                {meeting.contents.length > 0 && <Section>
                    {meeting.contents.map(a=><Content content={a} />)}
                </Section>}
                {meeting.trackers != null && meeting.trackers.length > 0 && <Section title="Trackers">
                    <table>
                        <thead>
                        <tr>
                            <th>Tracker</th>
                            <th>Topic</th>
                            <th>Mentions</th>
                        </tr>
                        </thead>
                        {meeting.trackers.map(a=><tr><td style={{whiteSpace: "nowrap"}}>{a.tracker}</td><td style={{whiteSpace: "nowrap"}}>{a.topic}</td><td>{a.mentions}</td></tr>)}
                    </table>
                </Section>}
                {meeting.questions.length > 0 && <Section title="Questions">
                    <table>
                        <thead>
                        <tr>
                            <th>Speaker</th>
                            <th>Topic</th>
                            <th>Question</th>
                        </tr>
                        </thead>
                        {meeting.questions.map(a=><tr><td style={{whiteSpace: "nowrap"}}>{a.speaker}</td><td style={{whiteSpace: "nowrap"}}>{a.topic}</td><td>{a.question}</td></tr>)}
                    </table>
                </Section>}
                {(meeting.sentences ?? []).length > 0 && <Section title="Discussion">
                <table>
                    <thead>
                    <tr>
                        <th>Speaker</th>
                        <th></th>
                    </tr>
                    </thead>
                    {meeting.sentences.map(a=><tr><td style={{whiteSpace: "nowrap"}}>{a.meetingParticipantName}</td><td>{a.sentenceText}</td></tr>)}
                </table>
                </Section>}
            </div>}
        </div>
    </>;
}